<template>
  <sub-section
    title="Can you still expect to get what you want?"
    helpTitle="What to take each year"
    :helpText="HelpText.incomeAndPotsCharts()"
  >
      <div class="row">
          <ul class="tab-header ">
              <li role="button"
                  tabindex="0"
                  @click="onTabClick(0)"
                  @keyup.enter="onTabClick(0)"
                  @keyup.space="onTabClick(0)"
                  :class="{
                    'tab-selected': selectedTabIndex == 0,
                    'tab-unselected': selectedTabIndex != 0
                  }"
                  :aria-label="incomeChartDescription">
                  Income
              </li>
              <li role="button"
                  tabindex="0"
                  @click="onTabClick(1)"
                  @keyup.enter="onTabClick(1)"
                  @keyup.space="onTabClick(1)"
                  :class="{
                    'tab-selected': selectedTabIndex == 1,
                    'tab-unselected': selectedTabIndex != 1
                  }"
                  :aria-label="potsChartDescription">
                  Your Pots
              </li>
          </ul>

          <div class="tab-content">
              <income-chart v-show="selectedTabIndex == 0"></income-chart>
              <pots-chart v-show="selectedTabIndex == 1"></pots-chart>
          </div>
      </div>
  </sub-section>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import IncomeChart from "@/guiide/components/charts/IncomeChart.vue";
import PotsChart from "@/guiide/components/charts/PotsChart.vue";
import SubSection from "@/guiide/components/common/SubSection.vue";
import HelpText from "@/guiide/ts/helpText";
import { retireeDescriber } from "@/guiide/ts/retireeDescriber";

export default defineComponent({
  name: "IncomeAndPots",
  components: {
    IncomeChart,
    PotsChart,
    SubSection
  },
  data() {
    return {
      HelpText,
      selectedTabIndex: 0
    };
  },
  computed: {
    incomeChartDescription(): string {
      return "Your income chart. A description of the chart: " + retireeDescriber.getIncomeChartDescription();
    },
    potsChartDescription(): string {
      return "Your pots chart. A description of the chart: " + retireeDescriber.getPotsChartDescription();
    }
  },
  methods: {
    onTabClick(index: number) {
      this.selectedTabIndex = index;
    }
  }
});
</script>

<style lang="css" scoped>
ul.tab-header {
  display: block;
  list-style: none;
  margin: 0 0 0 0;
  padding: 0;
}

ul.tab-header > li {
  padding: 5px 15px;
  border: lightgray solid 1px;
  margin: 0;
  display: inline-block;
  margin-right: 0px;
  cursor: pointer;
  color: darkslategray;
  width: 50%;
}

ul.tab-header > li.tab-selected {
  border-bottom: 0;
}

ul.tab-header > li.tab-unselected {
  background-color: #f7f7f6;
}

ul.tab-header > li.tab-unselected:hover {
  background-color: #fcfcfc;
}

.tab-content {
  padding-top: 45px;
  border: lightgrey solid 1px;
  border-top: 0;
}
</style>
